import { memo, forwardRef, useImperativeHandle, useRef } from 'react';
import { CJMenuItemDropDownValidationSchema, CJListOptionValidationSchema } from 'validators/schemas.validation';
// Import Types
import type { MenuItemDropdownRef } from 'components/MenuItemDropdown/types';
// Import Services
import { getCustomerJourneyFormFieldTranslatableErrorText } from 'services/customerJourney/helpers';
// Import Components
import MenuItemDropdown from 'components/MenuItemDropdown/MenuItemDropdown';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getUpdate: (update: { value?: any; isValid?: boolean }) => void;
    option: AnyObject;
    defaultValue?: { value: string | string[] };
    isMultiselect?: boolean;
    popoverAlign?: string;
    extendTargetWidth?: boolean;
    popoverClassName?: string;
    isValid?: boolean;
    errorText?: string;
}

export interface CJMenuItemDropdownRef {
    reset: MenuItemDropdownRef['reset'];
}

const CJMenuItemDropdown = forwardRef<CJMenuItemDropdownRef, Props>((props, ref) => {
    const {
        defaultValue,
        getUpdate,
        option,
        isMultiselect = false,
        popoverAlign,
        extendTargetWidth,
        popoverClassName,
        isValid,
        errorText,
    } = props;

    const menuItemDropdownRef = useRef<MenuItemDropdownRef>(null);

    useImperativeHandle(ref, () => ({
        reset: menuItemDropdownRef.current?.reset,
    }));

    const {
        CustomAttributes: { MenuItemId, SupportedValues, DisplayName },
    } = option;

    const validationSchema = isMultiselect
        ? CJListOptionValidationSchema(option)
        : CJMenuItemDropDownValidationSchema(option);

    return (
        <MenuItemDropdown
            ref={menuItemDropdownRef}
            defaultValue={defaultValue}
            getUpdate={getUpdate}
            menuItemId={MenuItemId}
            isMultiselect={isMultiselect}
            displayName={DisplayName}
            supportedValues={SupportedValues}
            validationSchema={validationSchema}
            getTranslatableErrorText={getCustomerJourneyFormFieldTranslatableErrorText}
            className="crm-cj-menu-item-dropdown"
            popoverAlign={popoverAlign}
            extendTargetWidth={extendTargetWidth}
            popoverClassName={popoverClassName}
            isValid={isValid}
            errorText={errorText}
        />
    );
});

CJMenuItemDropdown.displayName = 'CJMenuItemDropdown';

export default memo(CJMenuItemDropdown);
